import { render } from "./register-2.vue?vue&type=template&id=3bbfb8ea&scoped=true"
import script from "./register-2.vue?vue&type=script&lang=js"
export * from "./register-2.vue?vue&type=script&lang=js"

import "./register-2.vue?vue&type=style&index=0&id=3bbfb8ea&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbfb8ea"]])

export default __exports__